/**
 * For more information on the color scheme, see:
 * https://www.figma.com/design/OmW5EmO4N8b2II6s0aql2a/Greater-Web-Portal-UI?node-id=11-19315&t=BcbTDnPePM3gpPGR-4
 */

/** Base Colors */
export const transparent = {
  15: "hsla(0, 0%, 0%, 0.15)", // We use this for our boxShadow.primary
  10: "hsla(0, 0%, 0%, 0.1)",
  0: "hsla(0, 0%, 0%, 0)",
};

export const black = {
  100: "hsla(0, 0%, 0%, 1)", // #000000
};

export const white = {
  100: "hsla(0, 100%, 100%, 1)", // #FFFFFF
};

export const gray = {
  90: "hsla(240, 6%, 16%, 1)", // #282838
  80: "hsla(0, 1%, 37%, 1)", // #5F5E5E
  60: "hsla(0, 0%, 54%, 1)", // #8A8A8A
  50: "#F6F8FA", // ##F6F8FA
  40: "hsla(0, 0%, 85%, 1)", // #DADADA
  20: "hsla(0, 0%, 96%, 1)", // #F5F5F5
};

const primaryBlue = {
  100: "hsla(211, 100%, 50%, 1)", // #007CFF
  25: "hsla(211, 100%, 87%, 1)", // #BFDEFF
  10: "hsla(210, 100%, 95%, 1)", // #E5F2FF
  5: "hsla(212, 100%, 97%, 1)", // #F2F8FF
};

const seldomBlue = {
  100: "hsla(211, 100%, 67%, 1)", // #55A7FF
  25: "hsla(211, 100%, 92%, 1)", // #D4E9FF
  10: "hsla(212, 100%, 97%, 1)", // #EEF6FF
};

export const blue = {
  ...primaryBlue,
  seldom: seldomBlue,
};

export const red = {
  100: "hsla(0, 100%, 71%, 1)", // #FF6B6B
  25: "hsla(0, 100%, 93%, 1)", // #FFDADA
  10: "hsla(0, 100%, 97%, 1)", // #FFF0F0
};

export const gold = {
  100: "#FFD363", // rgb(255, 211, 99)
  60: "hsla(43, 97%, 44%, 1)", // #DB9E03
  25: "hsla(43, 75%, 86%, 1)", // #F6E7C0
  10: "hsla(43, 72%, 94%, 1)", // #FBF5E6
};

export const green = {
  100: "hsla(148, 100%, 37%, 1)", // #00BC57,
  25: "hsla(148, 58%, 84%, 1)", // #BFEED5
  10: "hsla(148, 58%, 94%, 1)", // #E5F8EE
};

export const purple = {
  100: "hsla(249, 80%, 67%, 1)", // #7B68EE
  25: "hsla(249, 81%, 92%, 1)", // #DED9FB
  10: "hsla(249, 76%, 97%, 1)", // #F2F0FD
};

/** Theme colors */

export const background = {
  white: white[100],
  light: gray[20],
  selected: blue[5],
  hover: blue[5],
  inactive: gray[20],
};

const colors = {
  transparent,
  black,
  white,
  gray,
  blue,
  red,
  gold,
  green,
  background,
};

export default colors;
